import React from 'react';
import ReactDOM from 'react-dom';
import {combineReducers} from 'redux';
import {Provider} from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import {Route, Switch} from 'react-router';
import {ConnectedRouter, routerReducer, routerMiddleware} from 'react-router-redux';

import PinCodeView from 'components/PinCodeView';
import ProductionNavBar from 'components/ProductionNavBar';
import configureStore from 'store';
import workLogs from 'ducks/workLogs';
import workers from 'ducks/workers';
import products from 'ducks/products';
import productDetail from 'ducks/productDetail';
import qualityControl from 'ducks/qualityControl';
import PrivateRoute from 'components/PrivateRoute';
import ProductList from 'components/ProductList';
import ProductDetails from 'components/ProductDetail';
import ProductQualityControl from 'components/ProductQualityControl';
import {USER_LANG} from 'utils/locale';

function initProductionView(config) {
    const production = document.getElementById('production');
    const header = document.getElementById('header');
    if (!production) {
        console.error("initProductionView() called but no #production present!");
        return;
    }
    if (!header) {
        console.error("initProductionView() called but no #header present!");
        return;
    }

    // Create a history of your choosing (we're using a browser history in this case)
    const history = createHistory();

    // Build the middleware for intercepting and dispatching navigation actions
    const middleware = routerMiddleware(history);


    // Create Redux store
    const rootReducer = combineReducers({
        workLogs,
        workers,
        products,
        productDetail,
        qualityControl,
        router: routerReducer,
    });
    const store = configureStore(rootReducer, [middleware]);

    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Switch>
                    <Route
                        exact
                        path={`/${USER_LANG}/production/auth`}
                        render={props => (
                            <PinCodeView
                                user={DJ_CONST.user}
                                deviceAuthorised={DJ_CONST.deviceAuthorised}
                                {...props}
                            />
                        )}
                    />
                    <PrivateRoute
                        exact
                        path={`/${USER_LANG}/production`}
                        component={ProductList}
                    />
                    <PrivateRoute
                        exact
                        path={`/${USER_LANG}/production/product/:id`}
                        component={ProductDetails}
                    />
                    <PrivateRoute
                        exact
                        path={`/${USER_LANG}/production/product/:id/quality-control`}
                        render={props => (
                            <ProductQualityControl
                                config={config}
                                {...props}
                            />
                        )}
                    />
                </Switch>
            </ConnectedRouter>
        </Provider>,
        production,
    );

    if (DJ_CONST.user === null) {
        ReactDOM.render(
            <Provider store={store}>
                <ProductionNavBar />
            </Provider>,
            header,
        );
    }
}


export default initProductionView;



// WEBPACK FOOTER //
// ./src/views/ProductionView.js